import React, { useEffect } from 'react';

import { UiDialog as Dialog } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';

import * as actions from './actions';
import ProposalForm from './components/ProposalForm';
import * as selectors from './selectors';

const Container = ({
    closeModal,
    fetchPanels,
    initialize,
    isInitializing,
    isNewRecord,
    isOpenModal,
    panelBrands,
    panels,
    reset,
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (isOpenModal) initialize();
    }, [isOpenModal]);

    useEffect(() => {
        return () => reset();
    }, []);

    return (
        <Dialog
            onClose={() => closeModal()}
            onExited={() => closeModal()}
            open={isOpenModal}
            title={`${isNewRecord ? t('Create') : t('Update')} ${t(
                'Proposal',
            ).toLowerCase()}`}
            size="sm"
        >
            <ProposalForm
                fetchPanels={fetchPanels}
                isFetching={isInitializing}
                panelBrands={panelBrands}
                panels={panels}
            />
        </Dialog>
    );
};

Container.propTypes = {
    closeModal: PropTypes.func,
    fetchPanels: PropTypes.func,
    initialize: PropTypes.func,
    isInitializing: PropTypes.bool,
    isNewRecord: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    panelBrands: PropTypes.array,
    panels: PropTypes.array,
    reset: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    isInitializing: selectors.getIsInitializing,
    isNewRecord: selectors.getIsNewRecord,
    isOpenModal: selectors.getIsOpenModal,
    panelBrands: selectors.getPanelBrandsData,
    panels: selectors.getPanelsData,
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => dispatch(actions.closeModal()),
    fetchPanels: (brandName) => dispatch(actions.fetchPanels(brandName)),
    initialize: () => dispatch(actions.initialFetching()),
    reset: () => dispatch(actions.reset()),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
)(Container);
